import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "header col" }
const _hoisted_2 = { class: "row tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "calendar-choice" }
const _hoisted_5 = ["onChange"]
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "buttons" }
const _hoisted_11 = { class: "trainer-table col" }
const _hoisted_12 = { class: "em row" }
const _hoisted_13 = { class: "nn row" }
const _hoisted_14 = { class: "cc row" }
const _hoisted_15 = { class: "bt row" }
const _hoisted_16 = { class: "trainer-buttons row" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled", "onClick"]
const _hoisted_19 = { class: "em row" }
const _hoisted_20 = { class: "nn row" }
const _hoisted_21 = { class: "cc row" }
const _hoisted_22 = { class: "bt row" }
const _hoisted_23 = { class: "trainer-buttons" }
const _hoisted_24 = ["disabled", "onClick"]
const _hoisted_25 = ["disabled", "onClick"]
const _hoisted_26 = {
  key: 0,
  class: "table row"
}
const _hoisted_27 = { class: "em row" }
const _hoisted_28 = { class: "nn row" }
const _hoisted_29 = { class: "cc row" }
const _hoisted_30 = { class: "bt row" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 1,
  class: "table row"
}
const _hoisted_33 = { class: "err-messages" }
const _hoisted_34 = { class: "buttons" }
const _hoisted_35 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "manage-calendar-modal",
    class: _normalizeClass({'grid': $setup.manageCalendarState === 'list'}),
    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("header", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("h1", null, "Manage Trainers and Calendars", -1)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.tabs, (t) => {
          return _createElementVNode("div", {
            key: `t-${t.state}`,
            class: _normalizeClass(["header-option", {'selected': t.state === $setup.manageCalendarState}]),
            onClick: ($event: any) => (($setup.manageCalendarState=t.state as typeof manageCalendarState))
          }, _toDisplayString(t.title), 11, _hoisted_3)
        }), 64))
      ])
    ]),
    ($setup.manageCalendarState === 'main')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[9] || (_cache[9] = _createElementVNode("div", null, "Main Calendar Management", -1)),
          (!$setup.calendarStore.main)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ($setup.privateStore.isValid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userCalendars, (cal) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: `nm-${cal.name}`
                          }, [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("input", {
                                type: "radio",
                                onChange: ($event: any) => ($setup.performMainSet(cal))
                              }, null, 40, _hoisted_5),
                              _createElementVNode("span", null, _toDisplayString(cal.name), 1)
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("button", {
                          disabled: $setup.googleLoading,
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.doUnlinkGoogle && $setup.doUnlinkGoogle(...args)))
                        }, "Unlink from Google", 8, _hoisted_7)
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[8] || (_cache[8] = _createElementVNode("p", null, "Main calendar not set up, and you're not attached to Google.", -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          disabled: $setup.googleLoading,
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.doLinkGoogle && $setup.doLinkGoogle(...args)))
                        }, "Link to Google", 8, _hoisted_9)
                      ])
                    ], 64))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("p", null, "Current main calendar: " + _toDisplayString($setup.calendarStore.main.name), 1),
                _createElementVNode("div", _hoisted_10, [
                  ($setup.calendarStore.userOwnsMain)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: $setup.performMainUnset
                      }, "Unset Main Calendar"))
                    : _createCommentVNode("", true),
                  ($setup.privateStore.isValid)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.doUnlinkGoogle && $setup.doUnlinkGoogle(...args)))
                      }, "Unlink from Google"))
                    : _createCommentVNode("", true)
                ])
              ], 64))
        ], 64))
      : ($setup.manageCalendarState === 'list')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_11, [
              _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"header row\"><div class=\"em row\">Email</div><div class=\"nn row\">Display Name</div><div class=\"cc row\">Color</div><div class=\"bt row\"> </div></div>", 1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.trainerList, (trainer) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "table row",
                  key: trainer.$id
                }, [
                  ($setup.editTrainerId === trainer.$id && $setup.workingTrainer)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(trainer.email), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            class: "input-el",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.workingTrainer.nickname) = $event))
                          }, null, 512), [
                            [_vModelText, $setup.workingTrainer.nickname]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode($setup["ColorSelector"], {
                            color: $setup.workingTrainer?.calendarColor,
                            state: "edit",
                            "onUpdate:color": $setup.updateColor
                          }, null, 8, ["color"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("button", {
                              class: "icon black",
                              disabled: $setup.trainerWorking,
                              onClick: $setup.submitTrainer
                            }, _cache[10] || (_cache[10] = [
                              _createElementVNode("svg", {
                                class: "svg icon save filled",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 18 18"
                              }, [
                                _createElementVNode("path", {
                                  class: "path icon save filled",
                                  d: "M14.6 0.6C14.2 0.2 13.7 0 13.2 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V4.8C18 4.3 17.8 3.8 17.4 3.42L14.6 0.6ZM9 16C7.3 16 6 14.7 6 13C6 11.3 7.3 10 9 10C10.7 10 12 11.3 12 13C12 14.7 10.7 16 9 16ZM10 6H4C2.9 6 2 5.1 2 4C2 2.9 2.9 2 4 2H10C11.1 2 12 2.9 12 4C12 5.1 11.1 6 10 6Z"
                                })
                              ], -1)
                            ]), 8, _hoisted_17),
                            _createElementVNode("button", {
                              class: "icon black",
                              disabled: $setup.trainerWorking,
                              onClick: ($event: any) => ($setup.deleteTrainer(trainer.$id))
                            }, _cache[11] || (_cache[11] = [
                              _createElementVNode("svg", {
                                class: "icon close",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  class: "path fill",
                                  d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                                })
                              ], -1)
                            ]), 8, _hoisted_18)
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(trainer.email), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(trainer.nickname), 1),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode($setup["ColorSelector"], {
                            color: trainer?.calendarColor,
                            state: "view",
                            "onUpdate:color": $setup.updateColor
                          }, null, 8, ["color"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("button", {
                              class: "icon black",
                              disabled: $setup.trainerWorking,
                              onClick: ($event: any) => ($setup.editTrainer(trainer.$id))
                            }, _cache[12] || (_cache[12] = [
                              _createElementVNode("svg", {
                                class: "icon edit fill filled white",
                                xmlns: "http://www.w3.org/2000/svg",
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                viewBox: "0,0,24,24"
                              }, [
                                _createElementVNode("path", {
                                  class: "path fill filled white",
                                  d: "M18,2l-3,3l4,4l3,-3zM14,6l-11,11v4h4l11,-11z"
                                })
                              ], -1)
                            ]), 8, _hoisted_24),
                            _createElementVNode("button", {
                              class: "icon black",
                              disabled: $setup.trainerWorking,
                              onClick: ($event: any) => ($setup.deleteTrainer(trainer.$id))
                            }, _cache[13] || (_cache[13] = [
                              _createElementVNode("svg", {
                                class: "icon close",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  class: "path fill",
                                  d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                                })
                              ], -1)
                            ]), 8, _hoisted_25)
                          ])
                        ])
                      ], 64))
                ]))
              }), 128)),
              ($setup.addNewTrainer && $setup.workingTrainer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.workingTrainer.email) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.workingTrainer.email]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.workingTrainer.nickname) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.workingTrainer.nickname]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode($setup["ColorSelector"], {
                        color: $setup.workingTrainer?.calendarColor,
                        state: "add",
                        "onUpdate:color": $setup.updateColor
                      }, null, 8, ["color"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("button", {
                        class: "icon black",
                        disabled: $setup.trainerWorking,
                        onClick: $setup.submitTrainer
                      }, _cache[14] || (_cache[14] = [
                        _createElementVNode("svg", {
                          class: "svg icon save filled",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 18 18"
                        }, [
                          _createElementVNode("path", {
                            class: "path icon save filled",
                            d: "M14.6 0.6C14.2 0.2 13.7 0 13.2 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V4.8C18 4.3 17.8 3.8 17.4 3.42L14.6 0.6ZM9 16C7.3 16 6 14.7 6 13C6 11.3 7.3 10 9 10C10.7 10 12 11.3 12 13C12 14.7 10.7 16 9 16ZM10 6H4C2.9 6 2 5.1 2 4C2 2.9 2.9 2 4 2H10C11.1 2 12 2.9 12 4C12 5.1 11.1 6 10 6Z"
                          })
                        ], -1)
                      ]), 8, _hoisted_31)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[15] || (_cache[15] = [
                    _createElementVNode("div", { class: "em row" }, null, -1),
                    _createElementVNode("div", { class: "nn row" }, null, -1),
                    _createElementVNode("div", { class: "cc row" }, null, -1),
                    _createElementVNode("div", { class: "bt row" }, null, -1)
                  ])))
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("p", null, _toDisplayString($setup.errMessages), 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", {
                class: "icon secondary",
                disabled: $setup.addNewTrainer || $setup.trainerWorking,
                onClick: $setup.startNewTrainer
              }, _cache[17] || (_cache[17] = [
                _createTextVNode("Add Trainer"),
                _createElementVNode("svg", {
                  class: "icon add",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    class: "path fill",
                    d: "M10.2 2L13.5 2L13.5 10.5L22 10.5L22 13.5L13.5 13.5L13.5 22L10.5 22L10.5 13.5L2 13.5L2 10.5 L10.5 10.5L10.5 2Z"
                  })
                ], -1)
              ]), 8, _hoisted_35),
              ($setup.addNewTrainer || $setup.trainerWorking)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "icon secondary",
                    onClick: $setup.back
                  }, "Back"))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
  ], 2))
}